<template>
  <div class="content-wrapper">
    <section class="content-customers pt-5">
      <div class="container">
        <div class="row">
          <div class="col-9">
            <h2>Complementary Kits</h2>
          </div>
          <div class="col-3">
            <input
              v-model="search"
              class="float-right form-control form-control-sm"
              placeholder="Search Complementary Kits"
            >
          </div>
        </div>
        <table class="table ">
          <thead>
            <tr>
              <th>Kit Voucher Code</th>
              <th>Date awarded</th>
              <th>Kit ID</th>
              <th>Transferred to</th>
              <th>Recipient email</th>
              <th>Kit Status</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="kits && kits.length > 0">
              <tr
                v-for="kit in orderedKits"
                :key="kit.id"
              >
                <td>{{ kit.voucherCode }}</td>
                <td>{{ formatDate(kit.orderDate) }}</td>
                <td>{{ kit.id }}</td>
                <td>
                  {{ kit.recipientFirstName }} {{ kit.recipientLastName }}
                </td>
                <td>{{ kit.recipientEmail }}</td>
                <td class="text-right">
                  <template v-if="!kit.transferred">
                    <a
                      href="#"
                      data-toggle="modal"
                      data-target="#giftKitModal"
                      @click="selectKit(kit)"
                    >
                      <template
                        v-if="kit.recipientEmail"
                      >Resend Kit Voucher</template>
                      <template v-else>Send Kit Voucher</template>
                    </a>
                  </template>
                  <strong
                    v-else
                    class="text-success"
                  >Kit Voucher Redeemed</strong>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td
                  colspan="5"
                  class="text-center"
                >
                  You don't currently have any complementary kits yet.
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <!-- /CONTAINER -->
    </section>

    <div
      id="giftKitModal"
      class="modal"
      tabindex="-1"
      role="dialog"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-content pt-3 pb-3">
            <div class="row">
              <div class="col-12 text-center">
                <h3>Transfer Kit</h3>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-5 offset-1">
                <div class="form-group   mb-1">
                  <input
                    v-model="transferForm.firstName"
                    v-validate="'required'"
                    name="inviteFirstName"
                    data-vv-scope="inviteForm"
                    :class="{
                      'is-invalid': errors.first('transferForm.firstName')
                    }"
                    class="form-control"
                    placeholder="First name"
                  >
                  <div class="invalid-feedback">
                    Please provide a first name
                  </div>
                </div>
              </div>
              <div class="col-5 ">
                <div class="form-group  mb-1">
                  <input
                    v-model="transferForm.lastName"
                    v-validate="'required'"
                    name="inviteLastName"
                    data-vv-scope="inviteForm"
                    :class="{
                      'is-invalid': errors.first('transferForm.lastName')
                    }"
                    class="form-control"
                    placeholder="Last name"
                  >
                  <div class="invalid-feedback">
                    Please provide a last name
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-10 offset-1 ">
                <div class="form-group w-100 mt-3 mb-1">
                  <input
                    v-model="transferForm.email"
                    v-validate="'required|email'"
                    name="email"
                    data-vv-scope="transferForm"
                    :class="{
                      'is-invalid': errors.first('transferForm.email')
                    }"
                    class="form-control w-100"
                    placeholder="Email"
                  >
                  <div class="invalid-feedback">
                    Please provide a valid email to transfer this kit to.
                  </div>
                </div>
              </div>
            </div>

            <div class="row mb-4 mt-4">
              <div class="col-10 offset-1 ">
                <a
                  class="btn btn-primary btn-block"
                  href="#"
                  @click.prevent="sendInvite"
                >
                  <span v-if="isLoading">
                    <i class="fas fa-spin fa-spinner" />
                  </span>
                  <span v-else>Transfer kit</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
import $ from 'jquery'
import moment from 'moment'
import _ from 'lodash'

export default {
  name: 'Patients',
  data () {
    return {
      isLoading: false,
      selectedKit: null,
      email: '',

      search: '',
      sortedBy: '',
      order: 'asc',

      transferForm: {
        firstName: '',
        lastName: '',
        email: ''
      }
    }
  },
  computed: {
    kits () {
      return this.$store.state.GET_COMP_KITS_WITH_RESULTS_RESPONSE
    },
    orderedKits () {
      const sorted = _.filter(this.kits, o => {
        const search = this.search.toLowerCase()

        return (
          o.voucherCode.toLowerCase().includes(search) ||
          (o.recipientFirstName + ' ' + o.recipientLastName)
            .toLowerCase()
            .includes(search) ||
          o.id.toString().includes(search)
        )
        // || o.recipientEmail.toLowerCase().includes(search)
      })
      return _.orderBy(sorted, [this.sortedBy], [this.order])
    }
  },
  mounted () {
    this.$store.dispatch('getComplementary')
  },
  methods: {
    sortBy (col) {
      if (this.sortedBy === col) {
        if (this.order === 'desc') {
          this.order = 'asc'
        } else {
          this.order = 'desc'
        }
      } else {
        this.sortedBy = col
        this.order = 'asc'
      }
    },
    selectKit (kit) {
      this.selectedKit = kit
    },
    formatDate (date) {
      if (date) {
        return moment(date).format('D/M/YYYY')
      }
      return ''
    },
    sendInvite () {
      this.$validator.validate('transferForm.*').then(() => {
        if (!this.errors.any()) {
          if (this.isLoading) return

          const payload = {
            kitId: this.selectedKit.id,
            email: this.transferForm.email,
            firstName: this.transferForm.firstName,
            lastName: this.transferForm.lastName
          }

          this.isLoading = true
          this.$store
            .dispatch('transferKit', payload)
            .then(() => {
              this.$store.dispatch('getComplementary')
              $('#giftKitModal').modal('hide')
            })
            .finally(() => {
              this.isLoading = false
            })
        }
      })
    }
  }
}
</script>
